import {
  Alert,
  Button,
  Card,
  CardBody,
  CardFooter,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Row,
  Table,
  UncontrolledDropdown,
} from "reactstrap";
import React, { useEffect, useState } from "react";
import PageHeader from "../common/PageHeader";
import withRedirect from "../../helpers/hoc/withRedirect";
import {
  PreloadState,
  Or,
  Message,
  isIterableArray,
} from "../UI/preloading/PreloadState";
import { Toast } from "../UI/toast/Toast";
import { useHistory } from "react-router-dom";
import {
  faInfoCircle,
  faPlus,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import useSWRFetchPagination from "../../helpers/hooks/useSWRFetchPagination";
import { getAllParking, removeParking } from "../../helpers/api/parking";
import FullPagination from "../common/pagination/FullPagination";
import FalconCardHeader from "../common/FalconCardHeader";
import ButtonIcon from "../common/ButtonIcon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SUCCESS_RESPONSE } from "../../helpers/codeResponses/codes";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import Swal from "sweetalert2";
import InfoText from "../UI/infoText/InfoText";
import classNames from "classnames";
import SupportLink from "../root/support/components/SupportLink";
import moment from "moment";
import { getDate } from "../../helpers/utils";

const Parking = () => {
  const history = useHistory();
  const {
    condominium: { selectedCondominium },
    auth: {
      user: { role },
    },
  } = useSelector((state) => state);
  const [textSearch, setTextSearch] = useState("");
  const [params, setParams] = useState({
    condominium: selectedCondominium,
    search: null,
  });

  useEffect(() => {
    setParams((prev) =>
      prev.condominium === selectedCondominium
        ? prev
        : { ...prev, condominium: selectedCondominium }
    );
  }, [selectedCondominium]);

  const applyParkingSearch = (value = textSearch) => {
    const term = typeof value === "string" ? value.trim() : "";
    setTextSearch(term);
    setParams((prev) => ({ ...prev, search: term || null }));
  };

  const {
    data,
    error,
    isLoading,
    mutate,
    meta,
    handler: { nextPage, previousPage, perPage, goToPage },
  } = useSWRFetchPagination(getAllParking, params);

  const dropParking = (id) => {
    Swal.fire({
      type: "warning",
      title: "Estas seguro?",
      text: "Seguro quieres eliminar este estacionamiento?",
      showCancelButton: true,
      confirmButtonText: `Si, eliminar`,
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#a932d0",
    }).then(async (result) => {
      if (!!result.value) {
        try {
          const res = await removeParking(id);
          if (res.code === SUCCESS_RESPONSE.OK) {
            mutate();
            Toast.fire({
              type: "success",
              title: `Se ha eliminado el estacionamiento`,
            });
          }
        } catch (error) {
          handleErrorMessage(error);
        }
      }
    });
  };

  return (
    <>
      <PageHeader
        title="Parqueos"
        titleTag="h2"
        description={
          "Si necesitas ayuda comunicanos, nuestra finalidad es ayudar a los usuarios para que puedan resolver inconvenientes."
        }
        className="mb-3"
        col={{ lg: 9 }}
      >
        <SupportLink />
      </PageHeader>
      <Card>
        <FalconCardHeader title={"Estacionamientos"}>
          <Row>
            <Col className="d-flex">
              <Input
                type="text"
                value={textSearch}
                onKeyPress={(event) => {
                  if (event.key === "Enter") applyParkingSearch(event.target.value);
                }}
                onChange={(event) => {
                  const value = event.target.value;
                  setTextSearch(value);
                  if (!value.trim()) {
                    setParams((prev) => ({ ...prev, search: null }));
                  }
                }}
                placeholder="Buscar por sigla o descripción..."
                className="d-inline-block search-input mr-2"
              />
              <ButtonIcon
                color="falcon-default"
                className="text-nowrap"
                icon={faSearch}
                onClick={() => applyParkingSearch()}
              >
                Buscar
              </ButtonIcon>
            </Col>
            {role === "manager" && (
              <Col
                xs={12}
                md={"auto"}
                className="mt-3 mt-md-0 text-center text-md-right"
              >
                <ButtonIcon
                  icon={faPlus}
                  color="falcon-default"
                  onClick={() => history.push(`/dashboard/parking/create`)}
                >
                  Añadir estacionamiento
                </ButtonIcon>
              </Col>
            )}
          </Row>
        </FalconCardHeader>
        <CardBody
          className={classNames("fs--1", { "p-0": isIterableArray(data) })}
        >
          <PreloadState cond={isIterableArray(data)} loading={isLoading}>
            <Or value={true}>
              <Table striped className="mb-0">
                <thead>
                  <tr>
                    <th width="5%" className="aling-middle">
                      ID
                    </th>
                    <th className="text-center align-middle">Acrónimo</th>
                    <th width="50%" className="aling-middle">
                      Descripción
                    </th>
                    <th className="text-center align-middle">
                      Fecha de creación
                    </th>
                    <th width="10%" className="text-center align-middle">
                      Opciones
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, i) => (
                    <tr key={i}>
                      <th className="align-middle">{item.parking_id}</th>
                      <td className="text-center align-middle">
                        {item.acronym}
                      </td>
                      <td className="align-middle">
                        <InfoText
                          clases={"m-0 p-0"}
                          max={45}
                          text={item.description}
                        />
                      </td>
                      <td className="text-center align-middle">
                        {getDate(item.created_at)}
                      </td>
                      <td className="text-center align-middle">
                        <UncontrolledDropdown direction="left">
                          <DropdownToggle color="falcon-default" size="sm">
                            <FontAwesomeIcon icon="ellipsis-h" />
                          </DropdownToggle>
                          <DropdownMenu>
                            <DropdownItem
                              onClick={() =>
                                history.push(
                                  `/dashboard/parking/${item.parking_id}/stalls`
                                )
                              }
                            >
                              Ver puestos
                            </DropdownItem>
                            {role === "manager" && (
                              <DropdownItem
                                onClick={() =>
                                  history.push(
                                    `/dashboard/parking/${item.parking_id}/edit`,
                                    { parking: item }
                                  )
                                }
                              >
                                Editar
                              </DropdownItem>
                            )}
                            {role === "manager" && (
                              <>
                                <DropdownItem divider />
                                <DropdownItem
                                  className="text-danger"
                                  onClick={() => dropParking(item.parking_id)}
                                >
                                  Eliminar
                                </DropdownItem>
                              </>
                            )}
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Or>
            <Or value={false} cond={!!error}>
              <Or value={false} cond={!!textSearch[0]}>
                <Message
                  value={true}
                  color={"info"}
                  className="p-3"
                  align="left"
                  icon={faInfoCircle}
                >
                  <>
                    No hemos encontrado un parqueo con el nombre{" "}
                    <b>"{textSearch}"</b>.
                  </>
                </Message>
                <Message
                  value={false}
                  color={"info"}
                  className="p-3"
                  align="left"
                  icon={faInfoCircle}
                >
                  No hay parqueos registrados, Puedes crear uno en la botón
                  "Añadir parqueo"
                </Message>
              </Or>
              <Or value={true}>
                <Alert color="danger" className="mb-0">
                  Esta página no está disponible
                  <Button
                    data-testid="Button"
                    color="link"
                    size="sm"
                    className="ml-1 pl-0"
                    onClick={() => history.goBack()}
                  >
                    Volver
                  </Button>
                </Alert>
              </Or>
            </Or>
          </PreloadState>
        </CardBody>
        <CardFooter className="border-top">
          {isIterableArray(data) && !isLoading && (
            <FullPagination
              nextPage={nextPage}
              prevPage={previousPage}
              goToPage={goToPage}
              meta={meta}
              className={"shadow-none"}
              posText={"Estacionamientos"}
              perPage={perPage}
            />
          )}
        </CardFooter>
      </Card>
    </>
  );
};

export default withRedirect(Parking);
